import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewEncapsulation, inject } from '@angular/core';
import { NavbarVerticalStyle2Component } from './vertical/style-2/style-2.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'app-navbar',
  styleUrls: ['./navbar.component.scss'],
  templateUrl: './navbar.component.html',
  imports: [NavbarVerticalStyle2Component],
})
export class NavbarComponent {
  private _elementRef = inject(ElementRef);
  // Private
  private _variant: string;

  /**
   * Constructor
   *
   * @param {ElementRef} _elementRef
   */
  public constructor() {
    // Set the private defaults
    this._variant = 'vertical-style-2';
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Variant
   */
  public get variant(): string {
    return this._variant;
  }

  @Input() public set variant(value: string) {
    // Remove the old class name
    this._elementRef.nativeElement.classList.remove(this.variant);

    // Store the variant value
    this._variant = value;

    // Add the new class name
    this._elementRef.nativeElement.classList.add('navbar');
  }
}
